import React from 'react';

const InviteHeader = ({ organizationName }) => {
  return (
    <div className="text-center mb-8">
      <div className="flex items-center justify-center mb-4">
        <img
          src="/assets/images/adu_flow_logo.png"
          alt="ADU Flow logo"
          className="h-16 w-auto object-contain"
        />
      </div>
      <h1 className="text-3xl font-bold text-foreground mb-2">You're Invited!</h1>
      <p className="text-muted-foreground">
        {organizationName
          ? `You've been invited to join ${organizationName} on ADU Flow.`
          : "You've been invited to join a team on ADU Flow."}
      </p>
      <p className="text-sm text-muted-foreground mt-1">
        Complete your account setup below to get started.
      </p>
    </div>
  );
};

export default InviteHeader;
